// import { RightOutlined } from '@ant-design/icons';
import { Card, Col, Row } from 'antd';
// Breadcrumb,
import set1 from './images/div.svg';
import arrow from './images/Vector 9.svg';
import styles from './index.module.less';
import React from 'react';
import { Link } from 'react-router-dom';

const SettingsPage = () => {
  const settingsData = [
    {
      title: 'Delegation Management',
      subtitle: 'Configure user delegation rules and periods',
      navigation: '/admin-settings/delegation-management',
      image: set1
    }
  ];

  return (
    <>
      {/* <div className={`${styles.breadcrub_container}`}>
        {' '}
        <Breadcrumb separator={<RightOutlined />}>
          <Breadcrumb.Item href="/admin-settings">Settings</Breadcrumb.Item>
        </Breadcrumb>
      </div> */}
      <Row className="mt-3">
        {settingsData?.map((item, index) => (
          <Col key={index} span={24}>
            <Link to={item.navigation}>
              <Card hoverable className={`mb-2 ${styles.settings_card}`}>
                <Row>
                  <Col span={20}>
                    <Row>
                      <Col>
                        {' '}
                        <img src={item.image} className="mr-2" />{' '}
                      </Col>

                      <Col span={10}>
                        <span className="sfprotext-bold font-14">
                          {item.title}
                        </span>
                        <br />
                        <span className="sfprotext-regular font-12">
                          {item.subtitle}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                  <Col className="df-jc-ac text-right" span={4}>
                    <img src={arrow} className="" />{' '}
                  </Col>
                </Row>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default SettingsPage;
